<template>
	<div class="loadArea">
		<b class="fa fa-spinner fa-spin"></b>
	</div>
</template>
<script>
    export default {
        name:"loadArea"
    }
</script>


